<template>
    <div class="ag-list-input mb-4">
        <div class="d-flex">
            <div class="d-flex col-4">
                <label class="form-label d-flex" style="height: min-content;"> {{ label }}<Tooltip
                        :text="tooltip || label"><i class="ag-icon ag-icon_table_info small info-icon" /></Tooltip>
                    </label>
            </div>
            <div class="d-flex gap-2 col-8">

                <div class="ag-input-inside">
                    <InputText v-model="newValue" :placeholder="placeholder" @keydown.enter.prevent="addItem" />
                    <Button class="ag-add-btn" label="Add" @click="addItem" />
                </div>
            </div>
        </div>
        <div v-if="items && items.length > 0" class="ag-list-all-div">
            <div v-for="(item, index) in items" :key="index" class="d-flex items-center">

                <div v-if="!hasDropdown" class="d-flex extension-row col-12">
                    <span class="dot">•</span>
                    <span class="ext-text">{{ item.applicationPath }}</span>
                    <button class="remove-btn" @click="removeItem(index)">−</button>
                </div>
                <!-- <span v-if="!hasDropdown" class="flex-1">{{ item }}</span> -->
                <template v-else>
                    <div class="extension-row col-5"><span class="dot">•</span>
                        <span class="ext-text">{{ item.fileExtension }}</span>
                        <button class="remove-btn" @click="removeItem(index)">−</button>
                    </div>
                    <Dropdown v-model="item.driverActionOverride" :options="ruleOptions" optionLabel="label"
                        optionValue="value" class=" col-7 file-type-dropdown"
                        @change="updateRule(index, item.driverActionOverride)" placeholder="Select Driver Action" />

                </template>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, defineProps, defineEmits } from "vue";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import Tooltip from "./tooltip.vue";

const props = defineProps({
    label: { type: String, required: true },
    placeholder: { type: String, default: "" },
    items: { type: Array, required: true },
    hasDropdown: { type: Boolean, default: false },
    tooltip: { type: String, default: "" },
});

const emit = defineEmits(["update:items"]);

const newValue = ref("");

function addItem() {
    if (!newValue.value) return;

    let val = newValue.value.trim();

    if (props.hasDropdown) {

        if (val && !val.startsWith(".")) {
            val = "." + val;
        }

        const item = {
            fileExtension: val,
            driverActionOverride: null
        };

        emit("update:items", [...(props.items || []), item]);
    } else {
        if (val && !val.includes("\\") && !val.includes("/")) {
            val = "*\\" + val;
        }

        const item = {
            applicationPath: val,
            folderMap: 0
        };

        emit("update:items", [...(props.items || []), item]);
    }

    newValue.value = "";
}

function removeItem(index) {
    const copy = [...props.items];
    copy.splice(index, 1);
    emit("update:items", copy);
}


function updateRule(index, rule) {
    const copy = [...props.items];
    copy[index] = { ...copy[index], driverActionOverride: rule };
    emit("update:items", copy);
}

const ruleOptions = [
    { label: "Conditional - Apply Runtime Rules", value: "Conditional - Apply Runtime Rules" },
    { label: "Allow - Always Allow Access", value: "Allow - Always Allow Access" },
    { label: "Deny - Always Deny Access", value: "Deny - Always Deny Access" },
];
</script>
<style scoped>
.ag-list-all-div {
    background: #f0f7ff;
    margin: 0 1rem;
    padding: 1rem;
}

.ag-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    color: #1f5aa6;
    margin-bottom: 6px;
}

.ag-info {
    font-size: 12px;
    color: #94a3b8;
}

.ag-input-inside {
    --add-btn-width: 50px;
    --add-btn-gap: 6px;
    position: relative;
    width: 100%;
}

.ag-input-inside :deep(.p-inputtext) {
    width: 100%;
    font-size: 14px;
    height: 32px;
    padding-right: calc(var(--add-btn-width) + var(--add-btn-gap) + 8px);
}

.ag-add-btn {
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
    width: var(--add-btn-width);
    height: calc(100% - 8px);
    padding: 0 8px;
    border-radius: 6px;
    background: #0b3d6d !important;
    border: 1px solid #0b3d6d !important;
    color: #fff !important;
    font-size: 0.7rem !important;
    ;
}

.ag-item-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f4f6fb;
    border-radius: 6px;
    padding: 6px 10px;
    margin-top: 8px;
    font-size: 13px;
}

.ag-item-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 75%;
}

.extension-row {
    display: flex;
    align-items: center;
    padding: 0;
    margin-bottom: 8px;
    border-radius: 4px;
}

.dot {
    color: #2f7ecf;
    font-size: 25px;
    margin-right: 6px;

}

.ext-text {
    font-weight: 500;
    padding-right: 8px;
    border-right: 1px solid #94a4b9;
}

.remove-btn {
    width: 18px;
    height: 18px;
    margin-left: 6px;
    margin-right: 8px;
    border-radius: 50%;
    border: none;
    color: #fff;
    background: #94a4b9;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    text-align: center;
    padding: 0;
}

.small-dropdown {
    font-size: 12px;
    padding: 4px 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.file-type-dropdown {
    font-size: 0.6rem !important;
    padding: 0.25rem 0.5rem;
    height: 32px;
    align-items: center;
}

.file-type-dropdown :deep(.p-inputtext) {
    font-size: 0.7rem !important;
}
</style>
